module.exports = __webpack_public_path__ + "static/media/Chapter 2 Slide 4 – 1.13d840e2.jpg";